import escapeHtml from 'escape-html'

export const EMBEDDED_COMPONENT_TYPES = [
  'data-vis', 'stock-card', 'technology-analysis-card', 'technology-card',
  'fund-inflows-card', 'fund-card', 'analyst-ratings-card', 'analyst-card',
  'fundamentals-card', 'marketpolymarketcard', 'market-polymarket-card',
  'news_aime-query', 'iframe',
]

export function getEmbeddedComponentType(element: Element): string | undefined {
  const names = (element.getAttribute('class') || '').toLowerCase().split(/\s+/)
  return names.find(name => EMBEDDED_COMPONENT_TYPES.includes(name))
    || EMBEDDED_COMPONENT_TYPES.find(name => name === element.nodeName.toLowerCase())
}

const ATTRIBUTES = new Set([
  'class', 'id', 'data', 'dataurl', 'tagvalue', 'code', 'symbol', 'ticker', 'datacode',
  'datastockname', 'eventid', 'eventslug', 'recinfo', 'traceid', 'number', 'title',
  'href', 'target', 'rel', 'src', 'width', 'height', 'allowfullscreen', 'loading',
  'referrerpolicy', 'sandbox', 'allow', 'frameborder',
])
const OMITTED_TAGS = new Set(['script', 'style', 'object', 'embed', 'base', 'link', 'meta', 'form'])
const VOID_TAGS = new Set(['br', 'hr', 'img', 'source'])

export function safeArticleUrl(value: string): string {
  const normalized = value.replace(/[\s\u0000-\u001f]/g, '')
  return /^(https?:|[/?#.]|[^:]*$)/i.test(normalized) ? value : ''
}

export function safeArticleLink(value: string): string {
  const normalized = value.replace(/[\s\u0000-\u001f]/g, '')
  return /^(mailto:|tel:)/i.test(normalized) ? value : safeArticleUrl(value)
}

// Preserve business payloads as inert editor data; never execute their HTML in the editor.
export function serializeEmbeddedElement(node: Node): string {
  if (node.nodeType === 3) return escapeHtml(node.textContent || '')
  if (node.nodeType !== 1) return ''
  const element = node as Element
  const tag = element.nodeName.toLowerCase()
  if (OMITTED_TAGS.has(tag)) return ''
  const attributes = Array.from(element.attributes).flatMap(({ name, value }) => {
    const key = name.toLowerCase()
    if (!ATTRIBUTES.has(key) && !key.startsWith('data-')) return []
    if (key === 'href' && !safeArticleLink(value)) return []
    if (key === 'src' && !safeArticleUrl(value)) return []
    return [` ${key}="${escapeHtml(value)}"`]
  }).join('')
  const children = Array.from(node.childNodes).map(serializeEmbeddedElement).join('')
  return VOID_TAGS.has(tag) ? `<${tag}${attributes}>` : `<${tag}${attributes}>${children}</${tag}>`
}
